<!-- project pane-->
<div id="main-map">

	<!-- navbar switcher -->
	<div id="fdm-sidebar-switch"
		[ngClass]="{ 'fdm-sidebar-switch-left': !sidenav.opened, 'fdm-sidebar-switch-right': sidenav.opened  }"
		(click)="sidenav.toggle()">
		<fa-icon [icon]="!sidenav.opened?'chevron-double-right':'chevron-double-left'"></fa-icon>
	</div>

	<!-- project info box -->
	<div id="project_info" class="fdm-box arrow-left" style="top:-500px;left:-500px;">
		<fa-icon class="fdm-linked fdm-text-large float-right" style="color:#fff;margin:2px 5px;" icon="times-circle" (click)="mouseSelect(null)"></fa-icon>
		<h1>{{ project_selected_obj?.name }}</h1>
		<div class="fdm-box-body clearfix">
			<table>
				<tr><td>{{ 'GENERIC.UPDATED' | translate }} <b>{{ project_selected_obj?.dateUpdated | dateAgo | async }}</b></td></tr>
				<tr><td>{{ 'GENERIC.CREATED' | translate }} <b>{{ project_selected_obj?.dateMade | dateAgo | async }}</b></td></tr>
				<tr *ngIf="project_selected_obj?.EPSGCode"><td>{{ 'PROJECTS.COORD_USE' | translate }} <b>{{ project_selected_obj?.EPSGCode }}</b> {{ 'PROJECTS.COORD_SYSTEM' | translate }}</td></tr>
				<tr *ngIf="!project_selected_obj?.EPSGCode"><td>{{ 'PROJECTS.NO_COORD' | translate }}</td></tr>
			</table>
			<button mat-flat-button color="accent" class="float-right" id="project_info_load" (click)="showHangOn();this.router.navigate(['/app/projects/map',project_selected_obj?.id]);" [class.noshow]="loading">
				<fa-icon icon="folder-open"></fa-icon> {{ 'GENERIC.OPEN' | translate }}
			</button>
		</div>
	</div>

	<app-quick-guides #quickguides *ngIf="permissions?.can?.show_intro_tour?.site_settings && (uiManager.toggleQuickGuide$ | async)?.screen == 'dashboard' && (uiManager.toggleQuickGuide$ | async)?.show" [context]="this" guidesMode="dashboard"></app-quick-guides>

	<!-- side navbar -->
    <mat-sidenav-container #sidenavContainer [autosize]="true" class="full-height" [hasBackdrop]="false">

        <mat-sidenav class="sidebar_outter light_color mat-elevation-z4 sidebar_float" position="start" #sidenav mode="over" [opened]="true">

			<!-- navbar header -->
			<div class="fdm-sidebar-header fdm-shadow clearfix">
				<h3>{{'NAV.MENU_PROJECTS' | translate }} - {{ fourD.activeTeam?.name }}</h3>
				<!-- <li>
					<span class="fdm-linked fdm-options-button pointer" (click)="addNew()" [matTooltip]="'PROJECTS.ADD_PROJECT_DESC' | translate">
						<fa-icon icon="plus"></fa-icon>
					</span>
				</li> -->


				<fa-icon [matTooltip]="'NAV.QUICK_GUIDES' | translate" style="color:rgb(208 240 224) !important;margin-top:-10px;font-size:20px;" (click)="openQuickGuides();" class="fdm-linked float-right" icon="question-circle"></fa-icon>

			</div>

			<!-- navbar content -->
			<div class="fdm-sidebar-body" (click)="mouseSelect(null);">

				<!-- <span (click)="doRotateGlobe ? stopRotateGlobe() : startRotateGlobe()">[{{ distanceToZero }}]</span> -->

				<!--
				<mat-slide-toggle color="primary" [checked]="doRotateGlobe" (click)="doRotateGlobe ? stopRotateGlobe() : startRotateGlobe()">
					Rotate
				</mat-slide-toggle><br/>

				<mat-slide-toggle *ngIf="fourD && fourD.activeTeam" color="primary" [(ngModel)]="fourD.activeTeam['showProjectTips']" (click)="saveActiveTeam();$event.stopPropagation()">
					Show tips
				</mat-slide-toggle><br/>
				-->

				<!-- You don't have any projects yet -->
				<mat-card *ngIf="!projects?.length">
					<div translate>PROJECTS.NEW_INTRO</div>
				</mat-card>

				<ul class="fdm-sidebar-list fdm-link" *ngIf="favouriteProjects.length > 0"> <!-- [routerLink]="['/app/projects/map',p.id]" -->

						<!-- favourite projects -->
						<li style="margin-top:10px;color:#888;padding-bottom:0;">{{ 'PROJECTS.FAVOURITES_LIST' | translate }}</li>
						<ng-container  *ngFor="let p of favouriteProjects; let i = index">
						<li id="project-{{ p.id }}" class="fdm-buttons fdm-hover-fade-in fdm-opacity-medium" (click)="mouseSelect(p);$event.stopPropagation();" (dblclick)="projectGoto()" [class.fdm-list-selected]="project_selected === p.id">

						<!-- project options -->
						<i *ngIf="permissions?.can?.delete?.project" class="fdm-icon fdm-icon-projects float-right fdm-icon-large-projects" style="margin-left:14px;"
						[matMenuTriggerFor]="menu"
						(click)="mouseSelect(p);$event.stopPropagation();"
						[matTooltip]="'PROJECTS.OPTIONS' | translate">
						<fa-icon icon="ellipsis-v"></fa-icon>
						</i>

						<!-- unpin favourite -->
						<i class="fdm-icon fdm-icon-projects float-right fdm-icon-large-projects" (click)="toggleProjectFavourite(p);$event.stopPropagation();"
							[matTooltip]="'PROJECTS.FAVOURITES_REMOVE' | translate">
							<fa-icon [class.fdm-icon-selected]="p.props.favourite" icon="star"></fa-icon>
						</i>

						<!-- quick-link load option -->
						<i class="fdm-icon fdm-icon-projects float-right fdm-icon-large-projects"
						(click)="mouseSelect(p);projectGoto();$event.stopPropagation();"
						[matTooltip]="'PROJECTS.QUICK_LOAD' | translate">
							<fa-icon icon="folder-open"></fa-icon>
						</i>

						<!-- project details -->
						<div class="fdm-listitem-title">
						<fa-icon class="" icon="folders"></fa-icon>
						{{ p.name }} <mat-chip *ngIf="p.props.isNew" color="accent" class="fdm-attention">{{ 'PROJECT.NEW' | translate }}</mat-chip>
						</div>

						<div class="fdm-listitem-metadata">{{ 'GENERIC.UPDATED' | translate }} <b>{{ p.dateUpdated | dateAgo | async }}</b> </div>

						<!-- debug -->
						<!-- <textarea style="width:100%;height:270px;font-size:10px;">{{ p | json }}</textarea> -->

					</li>

					<!-- Rename project -->
					<mat-menu #menu="matMenu" [overlapTrigger]="false">
						<button mat-menu-item (click)="renameProject(p)" *ngIf="permissions?.can?.edit?.project">
							<mat-icon>edit</mat-icon>
							<span translate>PROJECTS.RENAME</span>
						</button>

					<!-- Delete project -->
						<button mat-menu-item (click)="deleteProject(p)" *ngIf="permissions?.can?.edit?.project">
							<mat-icon>delete</mat-icon>
							<span translate>PROJECT.DELETE.TITLE</span>
						</button>
					</mat-menu>

					</ng-container>

				</ul>

				<div>
				<!--
					<div class="clearfix">
						<button class="float-right pointer" (click)="addNew()" mat-mini-fab color="primary" [matTooltip]="'PROJECTS.ADD_PROJECT_DESC' | translate" ><mat-icon>add</mat-icon></button>
						<h5 class="primary pt-2">{{'NAV.MENU_PROJECTS' | translate }}</h5>
					</div>
				-->

				<!-- project search -->
					<div *ngIf="projects?.length" class="fdm-tb-space fdm-form-field-tight fdm-form-field-neutral">
						<mat-form-field class="w-100 fdm-search-field" appearance="fill">
							<input matInput id="project-search" #searchprojects placeholder="{{ 'PROJECTS.SEARCH_PROJECTS' | translate }}" (keyup)="filterProjects($event.target.value)"  >
							<span matSuffix *ngIf="searchprojects.value.length > 0" (click)="searchprojects.value=''; filterProjects(searchprojects.value)" class="pointer"><fa-icon icon="times" class="fa-fw" ></fa-icon></span>
							<span class="mr-2" matPrefix (click)="filterProjects(searchprojects.value)"> <fa-icon icon="search" ></fa-icon></span>
						</mat-form-field>
					</div>

					<!-- project sort -->
					<div class="clearfix fdm-buttons" style="margin-left:10px;color:#666;border-bottom:solid 1px #ddd;">

						<div *ngIf="projects?.length" class="fdm-form-field-height-neutral fdm-form-field-padding-neutral fdm-form-field-tight float-right">
							<mat-form-field class="w-130px">
								<mat-select style="color:#bbb;font-size: 12px;height:15px;" [(ngModel)]="currentSortBy" id="project-sort" (selectionChange)="saveCurrentSortBy();sortProject()">
									<mat-option *ngFor="let sort of sortBy" [value]="sort">
									{{sort | translate }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>

						<!-- add new project -->
						<button *ngIf="permissions?.can?.create?.project" mat-flat-button [matTooltip]="'PROJECTS.ADD_PROJECT_DESC' | translate" class="fdm-button fdm-button-big" color="primary" id="add-project" (click)="addNew()">
							<fa-icon class="text-white" [icon]="['far','plus']"></fa-icon>
						</button>

					</div>

				</div>

				<div  class="text-center" *ngIf="loading">
					<mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
				</div>

				<ul class="fdm-sidebar-list fdm-link"> <!-- [routerLink]="['/app/projects/map',p.id]" -->

				<ng-container *ngFor="let p of filteredProjects; let i = index" >

					<span id="project-select"></span>

					<li id="project-{{ p.id }}" class="fdm-buttons fdm-hover-fade-in fdm-opacity-medium" (click)="mouseSelect(p);$event.stopPropagation();" [class.fdm-list-selected]="project_selected === p.id">

						<!-- project options -->
						<i class="fdm-icon fdm-icon-projects float-right fdm-icon-large-projects" style="margin-left:14px;"
							[matMenuTriggerFor]="menu"
							(click)="mouseSelect(p);$event.stopPropagation();"
							id="project-options"
							[matTooltip]="'PROJECTS.OPTIONS' | translate">
							<fa-icon icon="ellipsis-v"></fa-icon>
						</i>

						<!-- pin favourite -->
						<i class="fdm-icon fdm-icon-projects float-right fdm-icon-large-projects" (click)="toggleProjectFavourite(p);$event.stopPropagation();"
						id="project-favourites" [matTooltip]="'PROJECTS.FAVOURITES_ADD' | translate">
						<fa-icon [class.fdm-icon-selected]="p.props.favourite" icon="star"></fa-icon>
						</i>

						<!-- quick-link load option -->
						<i class="fdm-icon fdm-icon-projects fdm-icon-large-projects float-right"
						(click)="mouseSelect(p);projectGoto();$event.stopPropagation();" id="project-load" [matTooltip]=" 'PROJECTS.QUICK_LOAD' | translate">
						<fa-icon icon="folder-open"></fa-icon>
						</i>
						
						<!-- project details -->
						<div class="fdm-listitem-title">
							<fa-icon class="" icon="folders"></fa-icon>
							{{ p.name }} <mat-chip *ngIf="p.props.isNew" color="accent" class="fdm-attention">{{ 'GENERIC.NEW' | translate }}</mat-chip>
						</div>

						<div class="fdm-listitem-metadata">{{ 'GENERIC.UPDATED' | translate }} <b>{{ p.dateUpdated | dateAgo | async }}</b> </div>

						<!-- debug -->
						<!-- <textarea style="width:100%;height:270px;font-size:10px;">{{ p | json }}</textarea> -->

					</li>

					<!-- delete project -->
					<mat-menu #menu="matMenu" [overlapTrigger]="false">
						<button mat-menu-item (click)="renameProject(p)" *ngIf="permissions?.can?.edit?.project">
							<mat-icon>edit</mat-icon>
							<span translate>PROJECTS.RENAME</span>
						</button>
						<button mat-menu-item (click)="deleteProject(p)" *ngIf="permissions?.can?.edit?.project">
							<mat-icon>delete</mat-icon>
							<span translate>PROJECT.DELETE.TITLE</span>
						</button>
					</mat-menu>

				</ng-container>
				</ul>

			</div>

        </mat-sidenav>

        <mat-sidenav-content>
			<map-viewer></map-viewer>
        </mat-sidenav-content>

    </mat-sidenav-container>

      <!-- <button mat-icon-button
      [ngClass]="{
        'abs-top-left-offset' :sidenav.opened,
        'abs-top-left':!sidenav.opened
      }"
      (click)="sidenav.toggle()" class="light_color m-1">
      <fa-icon [icon]="!sidenav.opened?'chevron-double-right':'chevron-double-left'"></fa-icon>
      </button>
-->

      <!--<button *ngIf="!sidenav.opened" mat-icon-button class="abs-top-left light_color m-2" (click)="sidenav.toggle()">
        <fa-icon icon="chevron-double-right"></fa-icon>
      </button>-->
      <!--<div class="col-sm-3 mb-2" *ngFor="let p of projects">
          <mat-card class="example-card">

            <mat-card-header>
              <div mat-card-avatar><img class="full-width" [model]="p" vlink="image.png"></div>
              <mat-card-title>{{ p.name }}</mat-card-title>
            </mat-card-header>

            <mat-card-content>
              <p>
                  {{ p.desc }}
              </p>
            </mat-card-content>
            <mat-card-actions class="text-right">
              <a mat-icon-button [routerLink]="[p.id]" [matTooltip]="'PROJECTS.DETAILS' | translate " class="float-left"><fa-icon icon="wrench"></fa-icon></a>

              <a mat-icon-button [routerLink]="['map', p.id]" [matTooltip]="'PROJECTS.VIEW' | translate"><fa-icon icon="globe"></fa-icon> </a>

              <a mat-icon-button [routerLink]="['/map',p.id]" [target]="'_' + p.id" [matTooltip]="'PROJECTS.VIEW_FULL' | translate "><fa-icon icon="external-link-alt"></fa-icon></a>

            </mat-card-actions>
          </mat-card>
      </div>-->

</div>
